module.exports = __webpack_public_path__ + "assets/img/firework.48788721.png";